export default "__VITE_ASSET__AdpdJQlK__"